<template>

  <rate-calendar-bar
    :calendar-type="calendarType"
    :title="title"
  >

    <template v-slot:extras>
      <p>{{ costRange }}</p>
    </template>

  </rate-calendar-bar>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import RateCalendarBar from './RateCalendarBar.vue'
import type { NonEventBaseItem } from '../types'
import { currencyFormatter } from '../../../../../utils/formatters'

interface Props {
  item: NonEventBaseItem
  calendarType: string
}

const props = defineProps<Props>()

const title = computed<string>(() => {
  if (props.calendarType === 'month') {
    return `${productName.value} ${costRange.value}`
  } else {
    return productName.value
  }
})

const productName = computed<string>(() => {
  return props.item.locationProduct?.product?.name ?? '(unknown product)'
})

const costRange = computed<string>(() => {
  if (lowestCost.value === null || highestCost.value === null) {
    return ''
  } else if (lowestCost.value === highestCost.value) {
    return currencyFormatter.format(lowestCost.value)
  } else {
    return `${currencyFormatter.format(lowestCost.value)} – ${currencyFormatter.format(highestCost.value)}`
  }
})

const channelCosts = computed<number[]>(() => {

  const output: number[] = []

  props.item.defaultRates.forEach(dr => {
    dr.channelDefaultRates.forEach(cdr => {
      output.push(cdr.channelCost)
    })
  })

  return output

})

const lowestCost = computed<null | number>(() => {

  if (!props.item.defaultRates.length) {
    return null
  }

  return Math.min(...channelCosts.value)

})

const highestCost = computed<null | number>(() => {

  if (!props.item.defaultRates.length) {
    return null
  }

  return Math.max(...channelCosts.value)

})

</script>
